module.exports = __webpack_public_path__ + "img/lpr_day_up_selected.9435925f.svg";